import { render, staticRenderFns } from "./FileManagementChooseMany.vue?vue&type=template&id=161db06c"
import script from "./FileManagementChooseMany.vue?vue&type=script&lang=js"
export * from "./FileManagementChooseMany.vue?vue&type=script&lang=js"
import style0 from "./FileManagementChooseMany.vue?vue&type=style&index=0&id=161db06c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports